import { Box, Text } from '@wix/design-system';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const HeadingStructureRuleGenericCompletedStateNoTimeline = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP2",
    padding: "SP2 SP2 0 0"
  }, /*#__PURE__*/React.createElement(Box, {
    color: "G10"
  }, /*#__PURE__*/React.createElement(StatusCompleteFilledSmall, null)), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, text));
};
//# sourceMappingURL=heading-structure-rule-generic-completed-state-no-timeline.js.map